import {
    FEEDBACK_LIST_REQUEST, FEEDBACK_LIST_SUCCESS, FEEDBACK_LIST_FAIL,
    FEEDBACK_DETAILS_REQUEST, FEEDBACK_DETAILS_SUCCESS, FEEDBACK_DETAILS_FAIL, FEEDBACK_DETAILS_RESET,
    FEEDBACK_CREATE_REQUEST, FEEDBACK_CREATE_SUCCESS, FEEDBACK_CREATE_FAIL, FEEDBACK_CREATE_RESET,
    FEEDBACK_UPDATE_REQUEST, FEEDBACK_UPDATE_SUCCESS, FEEDBACK_UPDATE_FAIL, FEEDBACK_UPDATE_RESET,
    FEEDBACK_DELETE_REQUEST, FEEDBACK_DELETE_SUCCESS, FEEDBACK_DELETE_FAIL,
    FEEDBACK_DTO_REQUEST, FEEDBACK_DTO_SUCCESS, FEEDBACK_DTO_FAIL, FEEDBACK_DTO_RESET,
    FEEDBACK_LIST_BYIDS_REQUEST, FEEDBACK_LIST_BYIDS_SUCCESS, FEEDBACK_LIST_BYIDS_FAIL, FEEDBACK_LIST_BYIDS_RESET,
    SET_FEEDBACK_CURRENT_PAGE,
} from '../constants/feedbackConstants';

export const feedbackListReducer = (state = { feedbacks: [] }, action) => {
    switch (action.type) {
        case FEEDBACK_LIST_REQUEST:
            return { loading: true, feedbacks: [] };
        case FEEDBACK_LIST_SUCCESS:
            return {
                loading: false,
                feedbacks: action.payload.items,
                totalPages: action.payload.totalPages,
                totalCount: action.payload.totalCount,
                currentPage: action.payload.currentPage,
                statistics: action.payload.statistics
            };
        case SET_FEEDBACK_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };
        case FEEDBACK_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const feedbackListByIdsReducer = (state = { feedbacks: [] }, action) => {
    switch (action.type) {
        case FEEDBACK_LIST_BYIDS_REQUEST:
            return { loading: true, feedbacks: [] };
        case FEEDBACK_LIST_BYIDS_SUCCESS:
            return { loading: false, feedbacks: action.payload,
            };
        case FEEDBACK_LIST_BYIDS_FAIL:
            return { loading: false, error: action.payload };
        case FEEDBACK_LIST_BYIDS_RESET:
            return { feedbacks: [] };
        default:
            return state;
    }
};

export const feedbackDetailsReducer = (state = { feedback: {} }, action) => {
    switch (action.type) {
        case FEEDBACK_DETAILS_REQUEST:
            return { loading: true, ...state };
        case FEEDBACK_DETAILS_SUCCESS:
            return { loading: false, feedback: action.payload };
        case FEEDBACK_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case FEEDBACK_DETAILS_RESET:
            return { feedback: {} };
        default:
            return state;
    }
};

export const feedbackDtoReducer = (state = { feedbackDto: {} }, action) => {
    switch (action.type) {
        case FEEDBACK_DTO_REQUEST:
            return { loading: true, feedbackDto: {} };
        case FEEDBACK_DTO_SUCCESS:
            return { loading: false, feedbackDto: action.payload };
        case FEEDBACK_DTO_FAIL:
            return { loading: false, error: action.payload };
        case FEEDBACK_DTO_RESET:
            return { feedbackDto: {} };
        default:
            return state;
    }
};

export const feedbackDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case FEEDBACK_DELETE_REQUEST:
            return { loading: true };
        case FEEDBACK_DELETE_SUCCESS:
            return { loading: false, success: true };
        case FEEDBACK_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const feedbackCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case FEEDBACK_CREATE_REQUEST:
            return { loading: true };
        case FEEDBACK_CREATE_SUCCESS:
            return { loading: false, success: true, feedback: action.payload };
        case FEEDBACK_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case FEEDBACK_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const feedbackUpdateReducer = (state = { feedback: {} }, action) => {
    switch (action.type) {
        case FEEDBACK_UPDATE_REQUEST:
            return { loading: true };
        case FEEDBACK_UPDATE_SUCCESS:
            return { loading: false, success: true, feedback: action.payload };
        case FEEDBACK_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case FEEDBACK_UPDATE_RESET:
            return { feedback: {} };
        default:
            return state;
    }
}; 